module.exports = __webpack_public_path__ + "static/media/swiper.2428d691.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/swiper.png
// module id = 202
// module chunks = 0